module.exports = __webpack_public_path__ + "static/media/reportIcon.898d1656.svg";